export const numberOfAccessPoints = 'numberOfAccessPoints';
export const selectTheDevice = 'selectTheDevice';
export const optionBusinessWifi = 'Business Wifi';

export const pricingFields = [numberOfAccessPoints];
